export enum USERS {
    CHOICE_ADMIN = 'ChoiceAdministrator',
    ADMIN = 'SuperUser',
    USER = 'User'
}
